module.exports = __webpack_public_path__ + "static/media/white-logo-kiper.3b94eb9b.svg";